import ErrorHandler from '@/components/Error/ErrorHandler'
import FaturasPagasView from '@/components/Fatura/FaturasPagasView'
import Loading from '@/components/Loading'
import useAuth from '@/contexts/useAuth'
import { getFaturasPagas, type PagedFaturasResponse } from '@/services/fatura'
import type { Fatura } from '@/types/fatura'
import { useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'

const PAGE_SIZE = 12

export default function FaturasPagas() {
    const { empresaURL } = useParams<{ empresaURL: string }>()
    const { user } = useAuth()
    const [searchParams, setSearchParams] = useSearchParams()
    const page = Math.max(1, Number(searchParams.get('page') ?? 1) || 1)
    const [faturasPage, setFaturasPage] = useState<PagedFaturasResponse<Fatura> | null>(null)
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState<Error | null>(null)

    useEffect(() => {
        if (!user) return

        let cancelled = false
        ;(async () => {
            setIsLoading(true)
            try {
                const data = await getFaturasPagas(page, PAGE_SIZE)
                if (!cancelled) setFaturasPage(data)
            } catch (err) {
                if (!cancelled) setError(err as Error)
            } finally {
                if (!cancelled) setIsLoading(false)
            }
        })()

        return () => {
            cancelled = true
        }
    }, [page, user])

    const setPage = (nextPage: number) => {
        const params = new URLSearchParams(searchParams)
        params.set('page', String(nextPage))
        setSearchParams(params, { replace: true })
    }

    if (error) return <ErrorHandler error={error} />
    if (!user) return <Loading type="primary" />

    return (
        <FaturasPagasView
            faturasPage={faturasPage}
            isLoading={isLoading}
            backTo={`/${empresaURL}/faturas`}
            onPageChange={setPage}
        />
    )
}
